//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
export default {
  name: 'CopyAgentApp',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => ({}) },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        // description: '',
        type: '',
        // scheduler_type: '',
      },
      // 保存源应用id
      sourceId: '',
      rules: {
        id: [{ required: true, message: '请输入应用ID', trigger: 'blur' }],
        name: [{ required: true, message: '请输入应用名称', trigger: 'submit' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'submit' }],
        // description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
        // scheduler_type: [{ required: true, message: '请选择调度类型', trigger: 'submit' }],
      },
    };
  },
  // computed: {
  //   schedulerTypeDisabled() {
  //     return this.form.type === 'ma' || this.form.type === 'chatflow';
  //   },
  // },
  watch: {
    visible(val) {
      if (val) {
        // 预填原应用数据
        this.sourceId = this.row.id || '';
        this.form = {
          id: this.row.id ? `${this.row.id}_copy` : '',
          name: this.row.name ? `${this.row.name}-副本` : '',
          // description: this.row.description || '',
          type: this.row.type || '',
          // scheduler_type: this.row.scheduler_type || '',
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },

    handleCopy() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$request({
            url: this.$api.copyAgentApp,
            data: {
              source_id: this.sourceId,
              new_id: this.form.id,
              new_name: this.form.name,
              // new_description: this.form.description,
              // new_scheduler_type: this.form.scheduler_type,
            },
          }).then(() => {
            this.$message.success('复制成功');
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
